import React from 'react';
import BoardItem from '@amzn/awsui-board-components/board-item';
import { Card, CardBaseProps, CardHeader, i18nStrings } from './Card';
import { ReportIcon } from '../Home/Icons';

import styles from './Card.module.scss';

export const ViewRBNI = ({ onPanelChange }: CardBaseProps) => {
    return (
        <BoardItem
            i18nStrings={i18nStrings}
            header={
                <CardHeader dataHeaderId={Card.ViewRBNI} onPanelChange={onPanelChange}>
                    <ReportIcon />
                    <span className={styles.iconText}>View RBNI dashboard</span>
                </CardHeader>
            }
        >
            Go to Received But Not Invoiced (RBNI) Exposure Dashboard
        </BoardItem>
    );
};
